var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTableRemoveColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3H4C3.45 3 3 3.45 3 4V20C3 20.55 3.45 21 4 21H10C10.55 21 11 20.55 11 20V4C11 3.45 10.55 3 10 3ZM9 19H5V5H9V19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11H13V13H21V11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableRemoveColumn);
export default __webpack_public_path__ + "static/media/icon-table-remove-column.68b734b576699c59c989da858577e4d1.svg";
export { ForwardRef as ReactComponent };